import { Style, Fill, Stroke, Circle as CircleStyle, Text } from "ol/style";

export const getLayerStyle = (layer, feature) => {
    const geomType = feature.getGeometry().getType();
    let styleConfig = {};

    if (geomType.includes("Point")) {
        styleConfig = layer.styles.point;
    } else if (geomType.includes("LineString")) {
        styleConfig = layer.styles.line;
    } else if (geomType.includes("Polygon")) {
        styleConfig = layer.styles.polygon;
    }

    const opacity = styleConfig.opacity ?? 1;
    const classification = styleConfig.classification;
    const featureValue = classification?.field ? Number(feature.get(classification.field)) : undefined;
    const classificationColor =
        classification && Number.isFinite(featureValue)
            ? getClassificationColor(classification, featureValue)
            : null;

    const source = layer.meta?.source;
    let finalFillColor = styleConfig.fill;
    if (source === 'file') {
        finalFillColor = '#DB2777'; // fuchsia-600 for file upload
    } else if (source === 'manual') {
        finalFillColor = '#2563eb'; // blue-600 for direct input
    }

    let lineDash = undefined;
    switch (styleConfig.pattern) {
        case "dashed":
            lineDash = [6, 6];
            break;
        case "dotted":
            lineDash = [2, 6];
            break;
        default:
            lineDash = undefined;
    }

    const fillColor = classificationColor && (geomType.includes("Polygon") || geomType.includes("Point"))
        ? classificationColor
        : finalFillColor;
    const fill = fillColor
        ? new Fill({
            color: hexToRgba(fillColor, opacity),
        })
        : undefined;

    const strokeColor = classificationColor && geomType.includes("LineString")
        ? classificationColor
        : styleConfig.stroke;
    const stroke = strokeColor
        ? new Stroke({
            color: hexToRgba(strokeColor, opacity),
            width: styleConfig.width ?? 2,
            lineDash: lineDash,
        })
        : undefined;

    let text = undefined;
    if (styleConfig.labelField) {
        const labelValue = feature.get(styleConfig.labelField) ?? "";
        if (labelValue) {
            text = new Text({
                text: String(labelValue),
                font: "12px Calibri,sans-serif",
                fill: new Fill({ color: "#000" }),
                stroke: new Stroke({ color: "#fff", width: 3 }),
                overflow: true,
            });
        }
    }

    if (geomType.includes("Point")) {
        return new Style({
            image: new CircleStyle({
                radius: styleConfig.radius ?? 6,
                fill: fill,
                stroke: stroke,
            }),
            text,
        });
    } else {
        return new Style({
            fill,
            stroke,
            text,
        });
    }
};

function hexToRgba(hex, alpha) {
    let r = 0,
        g = 0,
        b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    return `rgba(${+r},${+g},${+b},${alpha})`;
}

function getClassificationColor(classification, value) {
    const { breaks = [], colors = [] } = classification;
    if (!colors.length) return null;
    for (let i = 0; i < colors.length; i += 1) {
        const upper = breaks[i] ?? Number.POSITIVE_INFINITY;
        if (value <= upper) {
            return colors[i];
        }
    }
    return colors[colors.length - 1];
}